<template>
  <div class="order-skeleton-component">
    <div class="h5"><OrderSkeletonH5 /></div>
    <div class="pc"><OrderSkeletonPc /></div>
  </div>
</template>
<script>
import OrderSkeletonH5 from './orderSkeletonH5.vue';
import OrderSkeletonPc from './orderSkeletonPc.vue';
export default {
  name: 'OrderSkeleton',
  components: {
    OrderSkeletonH5,
    OrderSkeletonPc,
  },
};
</script>
<style lang="scss" scoped>
.order-skeleton-component {
  .h5 {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .order-skeleton-component {
    .h5 {
      display: block;
    }
    .pc {
      display: none;
    }
  }
}
</style>
